<template>
    <div>
        <HeaderMember header="แก้ไขข้อมูลพนักงาน" :img_header="header_image" link_back="admin"/>
        <EditEmployee/>
    </div>
</template>

<script>
    import HeaderImage from '@/assets/add-user_1.png'
    import HeaderMember from '@/components/admin/member/headermember/HeaderMember.vue'
    import EditEmployee from "@/components/admin/member/admin/EditEmployee.vue";
    export default {
        name: "EditEmp",
        components: {
            HeaderMember,
            EditEmployee
        },
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
